export enum DatasetType {
    ACCOUNT_APPLICATION = 'ACCOUNT_APPLICATION',
    ACCOUNT_OVERLAY = 'ACCOUNT_OVERLAY',
    GLOBAL_OVERLAY = 'GLOBAL_OVERLAY',
    EXTERNAL_OVERLAY= 'EXTERNAL_OVERLAY',
}
